<template>
    <div class="container">
        <form action="#" @submit.prevent="submit">
            <field-input v-model="form.name" label="Name" :required="true"></field-input>
            <field-input v-model="form.email" type="email" label="Email" :required="true"></field-input>
            <field-phone v-model="form.phone" label="Phone" name="phone" :required="true"></field-phone>
            <field-text v-model="form.message" label="Message" :required="true"></field-text>
            <button type="submit" class="btn btn-block btn-app-blue" v-text="__('Submit')"></button>
        </form>
    </div>
</template>
<script>
    export default {

        data(){
            return {
                form: new Form({
                    name: '',
                    email: '',
                    phone:'',
                    message: '',
                })
            }
        },

        methods:{
            submit(){
                this.form.post(`/contact`).then(response => {
                    Alert.success(`Your message was sent successfully.<br>We will respond as soon as we can. Thank you!`);
                }).catch(errors => {
                    Alert.error(errors.first())
                })
            }
        }
    }
</script>
